import { useGameStore } from '../../store';

export default function BoostModal() {
  const show            = useGameStore((s) => s.showBoostModal);
  const completeBoostAd = useGameStore((s) => s.completeBoostAd);
  const setShow         = useGameStore((s) => s.setShow);

  if (!show) return null;

  return (
    <div className="modal-backdrop" style={{ display: 'flex' }}>
      <div className="modal-sheet">
        <div className="modal-title">🃏 점쟁이 길흉점지</div>
        <div className="modal-body" style={{ textAlign: 'center' }}>
          🔮<br /><br />점쟁이의 점지를 받으면 다음 물량풀기에서<br />
          <strong style={{ color: 'var(--up)' }}>수익 ×2</strong> /{' '}
          <strong style={{ color: 'var(--down)' }}>손실 ×0.5</strong>
        </div>
        <button className="modal-btn" onClick={completeBoostAd}>점지 받기</button>
        <button className="modal-btn ghost" onClick={() => setShow('showBoostModal', false)}>
          취소
        </button>
      </div>
    </div>
  );
}
